import React from 'react';

// Collabity clover: four rounded petals in a 4-fold rotational pattern.
// Two opposing petals in `leafA`, two opposing petals in `leafB`.
// Petal path points "up" from centre (50,50); the group is rotated 0/90/180/270.
const PETAL = 'M50 50 C 33 46 27 22 50 9 C 73 22 67 46 50 50 Z';

export const CloverMark = ({
  size = 40,
  leafA = '#34c800',
  leafB = '#0f172a',
  className = '',
  spin = false,
  style,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${spin ? 'animate-clover-breathe' : ''} ${className}`}
    role="img"
    aria-label="Collabity clover mark"
    style={style}
  >
    <path d={PETAL} fill={leafB} transform="rotate(0 50 50)" />
    <path d={PETAL} fill={leafA} transform="rotate(90 50 50)" />
    <path d={PETAL} fill={leafB} transform="rotate(180 50 50)" />
    <path d={PETAL} fill={leafA} transform="rotate(270 50 50)" />
  </svg>
);

// Wordmark: "collab" + accented "ity" with a green dot on the i.
export const CollabityWordmark = ({ className = '', base = '#ffffff', accent = '#34c800' }) => (
  <span className={`font-display font-extrabold tracking-tight ${className}`} style={{ color: base }}>
    collab<span style={{ color: accent }}>ity</span>
  </span>
);

export default CloverMark;
